import React from 'react'

const IconOrganizations = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='22'
      viewBox='0 0 20 22'
      fill='none'
    >
      <path
        d='M12.7493 0.75H7.14941V6.35H12.7493V0.75Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.1502 15.1499H13.5503V20.7499H19.1502V15.1499Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.34991 15.1499H0.75V20.7499H6.34991V15.1499Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.94961 7.1499V10.3499M3.94971 14.3499V11.1499H15.9495V14.3499'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconOrganizations
